import React, { useState } from 'react';
import styled from 'styled-components';
import { CoreCiIcon } from '../..';
import { FinanceLayer } from './FinanceLayer';
import { useI18n } from '@oneaudi/i18n-context';
import { useVehicle } from '../../../hooks';
import { replaceVehicleTitleAndSubtitle } from '../../../utils';
const InfoIWrapper = styled.button `
  margin-left: 6px;
  cursor: pointer;
  background: none;
  border: none;
`;
const Icon = styled.div ``;
export const FinanceInfoI = ({ vehicleId, financing, trackLayerLinkClick, trackFinInfoLayerClose, }) => {
    var _a;
    const [showLayer, setShowLayer] = useState(false);
    if (!(financing === null || financing === void 0 ? void 0 : financing.parameters) || !((_a = financing === null || financing === void 0 ? void 0 : financing.product) === null || _a === void 0 ? void 0 : _a.label)) {
        return null;
    }
    const { vehicle: vehicleBasic } = useVehicle(vehicleId);
    const financeInfoAriaLabel = replaceVehicleTitleAndSubtitle(useI18n({
        id: 'stockcars.prices.rate.info.arialabel',
        defaultMessage: '',
    }), vehicleBasic);
    const onClickHandler = (event) => {
        setShowLayer((prevState) => !prevState);
        if (trackLayerLinkClick !== undefined) {
            trackLayerLinkClick(event);
        }
    };
    const triggerRef = React.useRef(null);
    const finInfoLayerClose = () => {
        setShowLayer(false);
        if (trackFinInfoLayerClose !== undefined) {
            trackFinInfoLayerClose();
        }
        if (typeof window !== 'undefined') {
            setTimeout(() => {
                if (triggerRef.current) {
                    triggerRef.current.focus();
                }
            }, 50);
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(InfoIWrapper, { "data-testid": "finance-info-i", "aria-label": financeInfoAriaLabel, onClick: (event) => {
                onClickHandler(event);
            }, "data-tracking-exclude": true, ref: triggerRef },
            React.createElement(Icon, null,
                React.createElement(CoreCiIcon, { icon: "audi-system-info-small", size: "small" }))),
        showLayer && (React.createElement(FinanceLayer, { vehicleId: vehicleId, showLayer: showLayer, finInfoLayerClose: finInfoLayerClose }))));
};
